import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  TranslationFormModel, TranslationModel, TranslationProgressMentStatus,
  TranslationSupportiveLanguage
} from "../../models/translation.model";
import {BehaviorSubject, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TranslationService} from "../../services/translation.service";
import {TranslationUIService} from "../../services/translation-ui.service";
import {
  TranslationForms, TranslationFormsFrameId, TranslationStatus,
  TranslationToolNames
} from "../../models/translation.constants";

@Component({
    standalone: false,
    selector: 'particle-original-form',
  templateUrl: './original-form.component.html',
  styleUrls: ['./original-form.component.scss']
})
export class OriginalFormComponent implements OnInit, OnDestroy {
  @Input() formInfo$: BehaviorSubject<TranslationFormModel> = new BehaviorSubject(new TranslationFormModel());
  @Input() translationSupportiveLanguage: TranslationSupportiveLanguage[] = [];
  @Input() translationModel: TranslationModel = new TranslationModel();
  @Input() progressStatus$: BehaviorSubject<TranslationProgressMentStatus> = new BehaviorSubject(new TranslationProgressMentStatus());
  @Output() iframeLoadedEvent: EventEmitter<any> = new EventEmitter();
  translationToolNames = TranslationToolNames;
  formModel: TranslationFormModel = new TranslationFormModel();
  iFrameContent: any;
  frameId = TranslationFormsFrameId.LeftForm;
  unSubscribe$ = new Subject<void>();
  progressStatus: TranslationProgressMentStatus = new TranslationProgressMentStatus();

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private translationUIService: TranslationUIService,
              private translationService: TranslationService) {
    //this.iFrameContent = this.translationService.createFrame(this.frameId);
    this.iFrameContent = null;
  }

  ngOnInit() {
    this.formInfo$.pipe(takeUntil(this.unSubscribe$)).subscribe((formInfo: TranslationFormModel) => {
      //console.log('at left:', formInfo, this.formModel);
      if(formInfo && formInfo.hasPreview) { // I have something to show
        if(this.formModel && this.formModel.htmlFileId !== formInfo.htmlFileId) { // invalidate New html
          this.formModel = formInfo;
          this.iFrameContent = this.translationService.createFrame(this.frameId);
          this.changeDetectorRef.detectChanges();
          this.generatePageNumbers(this.formModel);
          this.getIFrameOnLoad();
          this.translationUIService.getHtmlForm(document, this.frameId, this.formModel.htmlFileId);
          //console.log('left form model:', this.formModel);
        }
      } else {
        this.formModel = formInfo;
        this.iFrameContent = null;
      }
    });
    this.progressStatus$.pipe(takeUntil(this.unSubscribe$)).subscribe((progress: TranslationProgressMentStatus) => {
      if(progress.formId === TranslationForms.LeftForm) {
        this.progressStatus = progress;
        //console.log('progress status:', progress);
      }
    });
  }

  private getIFrameOnLoad() {
    this.changeDetectorRef.detectChanges();
    const frame = <HTMLIFrameElement>document.getElementById(this.frameId);
    frame.addEventListener('load', () => {
      //console.log('right frame loaded.');
      this.leftFrameLoaded(frame);
    });

  }

  private leftFrameLoaded(rightFrame: HTMLIFrameElement) {
    this.iframeLoadedEvent.emit({frameId: this.frameId});
    if (this.translationModel.toolName === TranslationToolNames.Translation && this.translationModel.status === TranslationStatus.Completed) {
     // console.log('you can edit now');
      const divs = rightFrame.contentDocument.querySelectorAll('div');
      Array.from(divs).forEach((element: Element) => {
        element.setAttribute('contenteditable', 'true');
      });
    }
  }


  generatePageNumbers(formModel: TranslationFormModel) {
    if (formModel && formModel.pageCount > 0) {
      formModel.currentPage = 1;
      formModel.pages = Array(formModel.pageCount).fill(0);
    } else {
      formModel.pages = [];
    }
  }

  onChangeFromLanguage(data: any) {
    // todo
  }

  onChangeFromFileScanned(data: any) {
    //todo
  }

  onDownload() {
// todo:
  }

  jumpToPage(event) {
    this.formModel.currentPage = event.target.value;
    const frame = <HTMLIFrameElement>document.getElementById(this.frameId);
    const page = frame.contentDocument.querySelector(`body div[id='${this.formModel.currentPage}']`);
    if (page !== null) {
      page.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  ngOnDestroy(): void {

  }

}
